import React from "react";
import Footer from 'marketing-components/dist/components/organisms/footer';

const PPFooter = (props) => {
    const pageData = JSON.parse(document.getElementById('data-pageData') && document.getElementById('data-pageData').innerHTML) || {};
    const ppauth = pageData.ppauth;
    const marketingFooterComponent = JSON.parse(document.getElementById('mpp-footer') && document.getElementById('mpp-footer').innerHTML) || {};

    return (
        <>
            {!ppauth &&
                <Footer
                    content={marketingFooterComponent.content}
                    config={marketingFooterComponent.config}
                    localeCountry={marketingFooterComponent.localeCountry}
                    loggedIn={false}
                />
            }
        </>
    )
}

export default PPFooter;